var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 13.8842C8.22134 13.8842 9.35154 13.5788 10.3906 12.9682C11.4297 12.3575 12.2545 11.5326 12.8652 10.4936C13.4759 9.45451 13.7812 8.3243 13.7812 7.10295C13.7812 5.8816 13.4759 4.75139 12.8652 3.71233C12.2545 2.67327 11.4297 1.84841 10.3906 1.23773C9.35154 0.627054 8.22134 0.321716 6.99998 0.321716C5.77863 0.321716 4.64843 0.627054 3.60937 1.23773C2.57031 1.84841 1.74544 2.67327 1.13476 3.71233C0.524088 4.75139 0.21875 5.8816 0.21875 7.10295C0.21875 8.3243 0.524088 9.45451 1.13476 10.4936C1.74544 11.5326 2.57031 12.3575 3.60937 12.9682C4.64843 13.5788 5.77863 13.8842 6.99998 13.8842ZM8.87473 9.78947L8.94139 9.78263C9.03253 9.7644 9.10545 9.71883 9.16013 9.64591L9.65232 8.93498C9.70701 8.86206 9.72979 8.78003 9.72068 8.68888C9.71157 8.59774 9.67055 8.52482 9.59763 8.47013L7.76561 7.15764V3.27483C7.76561 3.18369 7.73371 3.10621 7.6699 3.04241C7.6061 2.97861 7.52863 2.94671 7.43748 2.94671H6.56248C6.47134 2.94671 6.39387 2.97861 6.33006 3.04241C6.26626 3.10621 6.23436 3.18369 6.23436 3.27483V7.7592C6.23436 7.86857 6.27993 7.95972 6.37108 8.03264L8.69529 9.72794C8.76821 9.78263 8.85024 9.80086 8.94139 9.78263L8.87473 9.78947Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.32f3e111e3fbd5ecc76d56fb6b4dcf3c.svg";
export { ForwardRef as ReactComponent };